// extracted by mini-css-extract-plugin
export default {"cls1":"cnZAONV65IKPWKk3msQ2","cls2":"sRpLFLR8zg0x4BRx9OXe cnZAONV65IKPWKk3msQ2"};